module.exports = __webpack_public_path__ + "assets/img/WS.ca1d9935.png";